<template>
  <div class="flex flex-col gap-6">
    <div class="grid grid-cols-3">
      <dl class="flex flex-col items-start">
        <dt>Acumulado</dt>
        <dd class="flex items-center gap-2">
          <profit-symbol-component :value="closedPnl" />
          <span class="text-ontick-steel-500 text-sm font-medium dark:text-gray-200">
            {{ closedPnl | currency }}
          </span>
        </dd>
      </dl>
      <dl class="flex flex-col items-center" v-if="getVisualizationMode === 'card'">
        <dt>Resultado</dt>
        <dd class="flex items-center gap-2">
          <profit-symbol-component :value="openPnl" />
          <span class="text-ontick-steel-500 text-sm font-medium dark:text-gray-200">
            {{ openPnl | currency }}
          </span>
        </dd>
      </dl>
      <dl class="flex flex-col items-center" v-else>
        <dt>Volume</dt>
        <dd class="flex items-center text-sm font-semibold text-gray-500 dark:text-gray-400">
          <template v-if="data.strategy_symbol === 'ANY'">
            <span
              v-if="data.volume_type === 'FIN_VOLUME'"
              :class="data.curr_positions.length ? 'font-bold text-gray-200' : 'text-gray-400'"
            >
              {{ !data.curr_positions.length ? "-/-" : multiSymbolVolume }}
            </span>
            <span
              v-else-if="data.volume_type === 'QUANTITY'"
              :class="data.curr_positions.length != 'Zerado' ? 'font-bold dark:text-gray-200' : 'text-gray-400'"
            >
              {{ !data.curr_positions.length ? "-" : multiSymbolVolume }}/{{ data.param_volume }}
            </span>
          </template>
          <template v-else-if="data.strategy_market === 'Equities'">
            <span
              v-if="data.volume_type === 'FIN_VOLUME'"
              :class="data.position_status != 'Zerado' ? 'font-bold text-gray-200' : 'text-gray-400'"
            >
              {{ data.position_status === "Zerado" ? "-/-" : data.position_volume }}
            </span>
            <span
              v-else-if="data.volume_type === 'QUANTITY'"
              :class="data.position_status != 'Zerado' ? 'font-bold dark:text-gray-200' : 'text-gray-400'"
            >
              {{ data.position_status == "Zerado" ? "-" : data.position_volume }}/{{ data.param_volume }}
            </span>
          </template>
          <template v-else>
            <span
              :class="
                data.position_status != 'Zerado'
                  ? 'text-ontick-steel-400 font-bold dark:text-gray-200'
                  : 'text-ontick-steel-500 dark:text-gray-400'
              "
              >{{ data.position_volume == 0 && data.position_status == "Zerado" ? "-" : data.position_volume }}
            </span>
            /
            <span>
              {{ data.param_volume }}
            </span>
          </template>
        </dd>
      </dl>
      <dl class="flex flex-col items-end">
        <dt>Posição</dt>
        <dd
          class="flex items-center gap-2 text-sm font-medium uppercase"
          :class="
            positionText === 'Zerado'
              ? 'text-ontick-steel-500 dark:text-gray-200'
              : 'text-ontick-yellow-900 dark:text-ontick-yellow-600'
          "
        >
          {{ positionText }}
        </dd>
      </dl>
    </div>
    <!-- <transition name="shrink"> -->
    <div class="grid grid-cols-3" v-if="getVisualizationMode === 'card'">
      <dl class="flex flex-col items-start">
        <dt>Perda máx.</dt>
        <dd class="text-ontick-red-600 flex items-center gap-1 text-sm font-medium">
          <span>
            {{ data.max_daily_loss | currency }}
          </span>
          <div class="scale-90 transform">
            <i v-html="$icons.info" class="text-gray-400"></i>
          </div>
        </dd>
      </dl>
      <dl class="flex flex-col items-center">
        <dt>Volume</dt>
        <dd class="flex items-center text-sm font-semibold text-gray-500 dark:text-gray-400">
          <template v-if="data.strategy_symbol === 'ANY'">
            <span
              v-if="data.volume_type === 'FIN_VOLUME'"
              :class="data.curr_positions.length ? 'font-bold text-gray-200' : 'text-gray-400'"
            >
              {{ !data.curr_positions.length ? "-/-" : multiSymbolVolume }}
            </span>
            <span
              v-else-if="data.volume_type === 'QUANTITY'"
              :class="data.curr_positions.length != 'Zerado' ? 'font-bold dark:text-gray-200' : 'text-gray-400'"
            >
              {{ !data.curr_positions.length ? "-" : multiSymbolVolume }}/{{ data.param_volume }}
            </span>
          </template>
          <template v-else-if="data.strategy_market === 'Equities'">
            <span
              v-if="data.volume_type === 'FIN_VOLUME'"
              :class="data.position_status != 'Zerado' ? 'font-bold text-gray-200' : 'text-gray-400'"
            >
              {{ data.position_status === "Zerado" ? "-/-" : data.position_volume }}
            </span>
            <span
              v-else-if="data.volume_type === 'QUANTITY'"
              :class="data.position_status != 'Zerado' ? 'font-bold dark:text-gray-200' : 'text-gray-400'"
            >
              {{ data.position_status == "Zerado" ? "-" : data.position_volume }}/{{ data.param_volume }}
            </span>
          </template>
          <template v-else>
            <span
              :class="
                data.position_status != 'Zerado'
                  ? 'text-ontick-steel-400 font-bold dark:text-gray-200'
                  : 'text-ontick-steel-500 dark:text-gray-400'
              "
              >{{ data.position_volume == 0 && data.position_status == "Zerado" ? "-" : data.position_volume }}
            </span>
            /
            <span>
              {{ data.param_volume }}
            </span>
            <i
              v-if="Object.keys(data).includes('pending_schedule')"
              class="p-1.5 cursor-pointer"
              v-html="$icons.warn_num_contracts"
              v-tippy="{ arrow: true, theme: 'green', placement: 'right' }"
              content="Alteração de volume agendada."
            ></i>
          </template>
        </dd>
      </dl>
      <dl class="flex flex-col items-end">
        <dt>Ganho máx.</dt>
        <dd class="text-ontick-green-600 flex items-center gap-2 text-sm font-medium">
          {{ data.max_daily_gain | currency }}
        </dd>
      </dl>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import profitSymbolComponent from "../profit-symbol.component.vue";

export default {
  components: { profitSymbolComponent },
  props: {
    data: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters({ getVisualizationMode: "investment/getVisualizationMode" }),
    openPnl() {
      if (this.isMultiSymbol) {
        if (this.data.curr_positions) {
          return this.data.curr_positions.reduce((acc, curr) => {
            return acc + (curr.open_pnl || 0);
          }, 0);
        }
        return 0;
      } else {
        return this.data.open_pnl;
      }
    },
    closedPnl() {
      if (this.data.strategy_symbol === "ANY") {
        return this.multiSymbolClosedPnl;
      } else {
        return this.data.closed_pnl + this.data.position_profit;
      }
    },
    multiSymbolClosedPnl() {
      if (this.data.curr_positions) {
        return (
          this.data.curr_positions.reduce((acc, curr) => {
            return acc + (curr.position_profit || 0);
          }, 0) + this.data.closed_pnl
        );
      }
      return 0;
    },
    isMultiSymbol() {
      return this.data.strategy_symbol === "ANY";
    },
    positionText() {
      switch (this.data.position_status) {
        case "Vendido":
        case "SELL":
          return "Venda";
        case "Comprado":
        case "BUY":
          return "Compra";
        default:
          return this.data.position_status;
      }
    },
    maxLoss() {
      return this.data.strategy_market === "Equities" ? this.data.max_loss * -1 : this.data.max_daily_loss;
    },
    maxGain() {
      return this.data.strategy_market === "Equities" ? this.data.max_gain : this.data.max_daily_gain;
    },
    tooltip() {
      if (this.data.strategy_market === "Equities") {
        const types = {
          FIN_VOLUME: `Quantidade a ser definida na abertura da posição (R$${this.data.curr_volume})`,
          QUANTITY: "Quantidade de ações (posicionados/parametrizados)",
        };
        return types[this.data.volume_type];
      } else {
        return "Volume (posicionados/parametrizados)";
      }
    },
    multiSymbolVolume() {
      if (this.data.curr_positions) {
        return this.data.curr_positions.reduce((acc, curr) => {
          return acc + (curr.position_volume || 0);
        }, 0);
      }
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
dl {
  dt {
    @apply text-xs text-gray-500 dark:text-gray-400;
  }
  dd {
    @apply font-semibold;
  }
}
.shrink {
  &-enter,
  &-leave-to {
    @apply scale-y-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transform transition-all duration-300;
  }
  // &-enter-to,
  // &-leave {
  //   @apply scale-y-0;
  // }
}
</style>
